var app = angular.module("leonardo");

var RoleModifiedDialog = function($scope, FormErrorsService) {

  $scope.role = $scope.ngDialogData.role;

  $scope.account_users = $scope.ngDialogData.account_users;

  $scope.account_users_ids = [];

  $scope.selectAllAccountUsers = function () {
    $scope.account_users_ids = ($scope.account_users_ids === 'all') ? [] : 'all';
  };

  $scope.isSelected = function (account_user) {
    return ($scope.account_users_ids === 'all') || (_.contains($scope.account_users_ids, account_user.id));
  };

  $scope.isAllSelected = function () {
    return ($scope.account_users_ids === 'all') || ($scope.account_users.length === $scope.account_users_ids.length);
  };

  $scope.selectAccountUser = function (account_user) {
    if (!angular.isArray($scope.account_users_ids)) {
      $scope.account_users_ids = [];
    }
    if (_.contains($scope.account_users_ids, account_user.id)) {
      $scope.account_users_ids.splice($scope.account_users_ids.indexOf(account_user.id), 1);
    }
    else {
      $scope.account_users_ids.push(account_user.id);
    }
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.confirm($scope.account_users_ids);
  };
};

app.controller('RoleModifiedDialog', ['$scope', 'FormErrorsService', RoleModifiedDialog]);
